import { createReducer, on } from '@ngrx/store';
import {
  ProductModel,
  ProductModelClass,
  ProductType,
  ProductTypeCategory
} from '../../models/dbmodels';
import { loadProductTypesFailure, loadProductTypesSuccess } from './product-types.actions';
import { ProductTypeSearchRequest } from 'src/app/models/viewmodels';

export interface ProductTypesState {
  productTypes: ProductType[];
  productTypeCategories: ProductTypeCategory[];
  productModelClasses: ProductModelClass[];
  productModels: ProductModel[];
  productSearchRequest: ProductTypeSearchRequest;

}

export const initialProductTypesState: ProductTypesState = {
  productTypes: [],
  productTypeCategories: [],
  productModelClasses: [],
  productModels: [],
  productSearchRequest: {} as ProductTypeSearchRequest
};

export const productTypesFeatureKey = 'productTypesState';

export const productTypesReducer = createReducer(
  initialProductTypesState,
  on(loadProductTypesSuccess, (state, { productTypes }): ProductTypesState => {

    const productTypeCategories = [];
    const productModelClasses = [];
    const productModels = [];

    productTypes.forEach((type) => {
      // check if there are any product type categories
      if (type.ProductTypeCategories == null || type.ProductTypeCategories.length === 0) {
        //if (type.Name == 'Residential') {
        //  productTypes.push(type);
          return;
        //}
      }
      productTypeCategories.push(...type.ProductTypeCategories);
      type.ProductTypeCategories.forEach((category) => {
        productModelClasses.push(...category.ProductModelClasses)
        category.ProductModelClasses.forEach((modelClass) => {
          productModels.push(...modelClass.ProductModels)
        })
      })
    })

    return <ProductTypesState>{
      ...state,
      productTypes,
      productTypeCategories,
      productModelClasses,
      productModels
    };
  }),

  on(loadProductTypesFailure, (state, { error }): ProductTypesState => {
    console.error(error);
    return state;
  }),
);


